import { useEffect } from 'react';

const SITE_ORIGIN = 'https://monthlynetworth.app';

function setMetaTag(attr, key, content) {
  let el = document.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}

// Keeps document title/description/canonical/robots in sync per-route for an SPA,
// since index.html only ships one static set of tags for every path.
export function usePageMeta({ title, description, path = '/', noindex = false }) {
  useEffect(() => {
    const previousTitle = document.title;
    document.title = title;
    setMetaTag('name', 'description', description);
    setMetaTag('property', 'og:title', title);
    setMetaTag('property', 'og:description', description);

    let canonicalEl = document.querySelector('link[rel="canonical"]');
    if (!canonicalEl) {
      canonicalEl = document.createElement('link');
      canonicalEl.setAttribute('rel', 'canonical');
      document.head.appendChild(canonicalEl);
    }
    canonicalEl.setAttribute('href', `${SITE_ORIGIN}${path}`);

    setMetaTag('name', 'robots', noindex ? 'noindex, nofollow' : 'index, follow');

    return () => {
      document.title = previousTitle;
    };
  }, [title, description, path, noindex]);
}
